import useTranslate from "@hooks/use_translate"
import { Box, Stack, Tooltip, Typography } from "@mui/material"

type Entry = {
  label: string
  hintKey: string
  light: { color: string; background: string }
  dark: { color: string; background: string }
}

const ENTRIES: Entry[] = [
  {
    label: "{{variable}}",
    hintKey: "prompt_template_variable_hint",
    light: { color: "#1b5e20", background: "rgba(46, 125, 50, 0.15)" },
    dark: { color: "#a5d6a7", background: "rgba(76, 175, 80, 0.25)" }
  },
  {
    label: "{{#if_x}}",
    hintKey: "prompt_template_conditional_hint",
    light: { color: "#e65100", background: "rgba(230, 81, 0, 0.22)" },
    dark: { color: "#ffb74d", background: "rgba(255, 152, 0, 0.28)" }
  },
  {
    label: "{{#block:x}}",
    hintKey: "prompt_template_block_hint",
    light: { color: "#6a1b9a", background: "rgba(106, 27, 154, 0.2)" },
    dark: { color: "#ce93d8", background: "rgba(186, 104, 200, 0.28)" }
  }
]

/** Explains the editor's token colours, so "why did that text vanish" is answerable in place. */
export default function TemplateLegend() {
  const { translate } = useTranslate()

  return (
    <Stack direction="row" spacing={0.75} alignItems="center" flexWrap="wrap">
      {ENTRIES.map((entry) => (
        <Tooltip
          key={entry.label}
          title={translate(entry.hintKey)}
          arrow
          placement="top"
        >
          <Box
            component="span"
            sx={(theme) => {
              const palette =
                theme.palette.mode === "dark" ? entry.dark : entry.light
              return {
                px: 0.5,
                borderRadius: 0.5,
                cursor: "help",
                fontFamily: "monospace",
                fontSize: "0.7rem",
                lineHeight: 1.6,
                color: palette.color,
                backgroundColor: palette.background
              }
            }}
          >
            {entry.label}
          </Box>
        </Tooltip>
      ))}
      <Typography
        variant="caption"
        sx={{ color: "text.secondary", whiteSpace: "nowrap" }}
      >
        {translate("prompt_template_tinted_caption")}
      </Typography>
    </Stack>
  )
}
